var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTwoFa = function SvgAlertTwoFa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4021 6.80004H8.13542V9.26671H11.8021C11.7354 9.86671 11.3354 10.8 10.4688 11.4C9.93542 11.8 9.13542 12.0667 8.13542 12.0667C6.40208 12.0667 4.86875 10.9334 4.33542 9.26671C4.20208 8.86671 4.13542 8.40004 4.13542 7.93337C4.13542 7.46671 4.20208 7.00004 4.33542 6.60004C4.40208 6.46671 4.40208 6.33337 4.46875 6.26671C5.06875 4.86671 6.46875 3.86671 8.13542 3.86671C9.40208 3.86671 10.2021 4.40004 10.7354 4.86671L12.6021 3.00004C11.4687 2.00004 9.93542 1.33337 8.13542 1.33337C5.53542 1.33337 3.26875 2.80004 2.20208 5.00004C1.73542 5.93337 1.46875 6.93337 1.46875 8.00004C1.46875 9.06671 1.73542 10.0667 2.20208 11C3.26875 13.2 5.53542 14.6667 8.13542 14.6667C9.93542 14.6667 11.4687 14.0667 12.5354 13.0667C13.8021 11.9334 14.5354 10.2 14.5354 8.13337C14.5354 7.60004 14.4688 7.20004 14.4021 6.80004Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAlertTwoFa;